import styled from 'styled-components';
import { BLACK, NEUTRAL_100, PALE_BLUE, WHITE } from '@styles/colors';
import { INTER } from '@styles/fonts';
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 16px 12px 40vw 12px;
  overflow-y: auto;
  gap: 16px;
`;

export const ViewModeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

export const EmptyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
`;

export const EmptyListText = styled.span`
  color: ${BLACK};
  font-family: ${INTER.extraLight};
  text-align: center;
  margin-bottom: 16px;
  width: 80%;
`;

export const EWalletItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  padding: 16px 12px;
  background-color: ${PALE_BLUE};
`;

export const BottomButtonContainer = styled.div`
  background-color: ${WHITE};
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  border-top: 1px solid ${NEUTRAL_100};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
`;

// Styled components for EWalletForm
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const FormTopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto; // this cause a mysterius white space at the bottom of the form
`;

export const FormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 12px 32px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  gap: 16px;
`;

export const FormButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${WHITE};
`;
